module.exports = __webpack_public_path__ + "img/iTrailBlazers.c75878f2.png";